import { I18n } from '@calendly/i18n'
import { CheckboxInput } from '@calendly/ui/components/checkbox-input'

import { Statuses } from 'constants/meetings'

import { CheckboxFilterLayout } from '../filter_layout'
import { OptionWrapper, StyledLabel } from '../styles'

export const CheckboxStatus = ({ params, onChange, useColumnLayout = false, useShortLabel = false }) => {
  const { status_ids: statusIds, status_explicitly_set: statusExplicitlySet = false } = params

  const isDefaultState = statusIds.length === 1 && statusIds[0] === Statuses.ACTIVE && !statusExplicitlySet

  const onSelect = (value) => {
    if (isDefaultState) {
      onChange({
        ...params,
        status_ids: [value],
        status_explicitly_set: true
      })
      return
    }

    const newStatusIds = statusIds.includes(value)
      ? statusIds.filter((v) => v !== value)
      : [...statusIds, value]

    if (newStatusIds.length === 0) {
      onChange({
        ...params,
        status_ids: [Statuses.ACTIVE],
        status_explicitly_set: false
      })
      return
    }

    onChange({
      ...params,
      status_ids: newStatusIds,
      status_explicitly_set: true
    })
  }

  return (
    <CheckboxFilterLayout
      label={useShortLabel
        ? I18n.t('publisher.meetings.filter_modal.status.label')
        : I18n.t('publisher.meetings.filter_modal.status.meeting_status')}
      useColumnLayout={useColumnLayout}
    >
      <OptionWrapper>
        <StyledLabel>
          <CheckboxInput
            checked={!isDefaultState && statusIds.includes(Statuses.ACTIVE)}
            onChange={() => onSelect(Statuses.ACTIVE)}
          />
          {I18n.t('publisher.meetings.filter_modal.status.scheduled')}
        </StyledLabel>
      </OptionWrapper>
      <OptionWrapper>
        <StyledLabel>
          <CheckboxInput
            checked={statusIds.includes(Statuses.CANCELED)}
            onChange={() => onSelect(Statuses.CANCELED)}
          />
          {I18n.t('publisher.meetings.filter_modal.status.canceled')}
        </StyledLabel>
      </OptionWrapper>
      <OptionWrapper>
        <StyledLabel>
          <CheckboxInput
            checked={statusIds.includes(Statuses.RESCHEDULED)}
            onChange={() => onSelect(Statuses.RESCHEDULED)}
          />
          {I18n.t('publisher.meetings.filter_modal.status.rescheduled')}
        </StyledLabel>
      </OptionWrapper>
      <OptionWrapper>
        <StyledLabel>
          <CheckboxInput
            checked={statusIds.includes(Statuses.NO_SHOW)}
            onChange={() => onSelect(Statuses.NO_SHOW)}
          />
          {I18n.t('publisher.meetings.filter_modal.status.no_show_attendees')}
        </StyledLabel>
      </OptionWrapper>
    </CheckboxFilterLayout>
  )
}
